import { capitalize } from "lodash";

export function reasonableGuessAtNaming(platform: string) {
  return platform
    .trim()
    .split(/[_ ]+/)
    .map((i) => capitalize(i))
    .join(" ");
}
